export const PAGE_SIZE = 50;
//# sourceMappingURL=types.js.map